<div>
	<staff-engagement-counts [data]="staffEngagementData()"></staff-engagement-counts>
</div>